export { indexedComparator, namedIndexedComparator } from "./indexedComparator";
